//import { createBrowserHistory } from "history";
import { createHashHistory } from "history";

export default createHashHistory({forceRefresh:true}); 